import DI from '../../app/di'
import { IUserService } from '../../interfaces/services/user'
import { on } from '../listener'
import * as actions from './actions'

on(actions.getUser, async (_action, api) => {
  const userService = DI.get('UserService') as IUserService

  api.dispatch(actions.getUserComplete(await userService.getUser()))
})
